import React from 'react';
import Heading from '../../../common/heading/Heading';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import {
	ONBOARDING_LINK_ALREADY_USED_TITLE,
	ONBOARDING_LINK_ALREADY_USED_TEXT,
	ONBOARDING_LINK_ALREADY_USED_BUTTON,
} from '../../../../constants/Copy';
import { ROUTE_LOGIN } from '../../../../constants/Routes';

export default () => (
	<div className="onboarding-email-verified">
		<Heading>{ONBOARDING_LINK_ALREADY_USED_TITLE}</Heading>
		<p className="onboarding__text">{ONBOARDING_LINK_ALREADY_USED_TEXT}</p>
		<Button onClick={ROUTE_LOGIN}>{ONBOARDING_LINK_ALREADY_USED_BUTTON}</Button>
	</div>
);
